// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.style-module_wrapper_OHa3w9xOup6gbJL22qFW {
  margin: 4rem 0rem 6rem 0rem;
}`, "",{"version":3,"sources":["webpack://./src/components/PageTabs/style.module.scss"],"names":[],"mappings":"AAAA;EACE,2BAAA;AACF","sourcesContent":[".wrapper {\n  margin: 4rem 0rem 6rem 0rem;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `style-module_wrapper_OHa3w9xOup6gbJL22qFW`
};
export default ___CSS_LOADER_EXPORT___;
